import React, { Component } from 'react';
import { setAndGetAttributes } from '../FormInputFields/FormInputFunctions';
import { currencyListUtil } from '../../Utils/CommonFunctions';
import { callPOST } from '../../Utils/ApiUtil';
import Wrp from '../../hoc/Wrp/Wrp';
import ExchangeRateConversion from '../FormBuilder/Builder/FormInputs/ExchangeRateConversion';

class PagesCurrency extends Component {
  state = {
    historyCurrency: 0,
    currentCurrencyValue: '',
    currencyValue: '',
    bottomPopup: false,
    currencyCode: this.props.currencycode || 'CAD',
    isOpenCurrencyConversion: false,
    exchangeRates: {
      exchange_rate: '',
      from_currency_code: '',
      to_currency_code: '',
      value: ''
    }
  };

  componentDidMount() {
    setTimeout(() => {
      this.syncValueFromProps(this.props.value);
    }, 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.syncValueFromProps(this.props.value);
    }

    if (
      prevProps.currencyCode !== this.props.currencyCode &&
      this.props.currencyCode
    ) {
      this.setState({ currencyCode: this.props.currencyCode });
    }
  }

  syncValueFromProps = (value) => {
    let parsed = value;
    if (typeof value === "string") {
      try { parsed = JSON.parse(value); } catch { }
    }
    const isObj = parsed && typeof parsed === "object";    
    this.setState({
      currencyValue: isObj ? parsed.value : parsed || "",
      currencyCode: isObj ? parsed.currency_code : this.state.currencyCode
    });
  };


  toFixedHandler = (value) => {
    const decimal =
      this.props.decimal !== null && this.props.decimal !== undefined
        ? this.props.decimal
        : 2;
    return parseFloat(value || 0).toFixed(decimal);
  };

  showHistoryPopup = () => {
    this.setState((prev) => ({ bottomPopup: !prev.bottomPopup }));
  };

  setHistoryValue = () => {
    const fixedValue = this.toFixedHandler(this.state.historyCurrency);
    this.updateValue(fixedValue);
  };

  applyCalculatedValue = () => {
    const fixedValue = this.toFixedHandler(this.state.currentCurrencyValue);
    this.updateValue(fixedValue);
  };

  updateValue = (value) => {
    this.setState({ currencyValue: value, bottomPopup: false });
    this.props.changeHandler({
      currency_code: this.state.currencyCode,
      value
    });
  };

  currencyOnBlur = (value) => {
    const rgx = /(\d+)(?:\s*)([\+\-\*\/])(?:\s*)(\d+)/;
    const fixedValue = this.toFixedHandler(
      rgx.test(value) ? this.state.currentCurrencyValue : value
    );

    this.setState({
      currencyValue: fixedValue,
      currentCurrencyValue: value,
      bottomPopup: false
    });

    this.props.changeHandler({
      currency_code: this.state.currencyCode,
      value: fixedValue
    });
  };

  currencyOnChange = (value) => {
    const rgx = /(\d+)(?:\s*)([\+\-\*\/])(?:\s*)(\d+)/;

    try {
      this.setState({ currencyValue: value, bottomPopup: true });

      if (rgx.test(value)) {
        const evaluated = eval(value);
        this.setState({
          historyCurrency: value,
          currentCurrencyValue: evaluated
        });
      } else {
        this.setState({ currentCurrencyValue: value });
        this.props.changeHandler({
          currency_code: this.state.currencyCode,
          value
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  toogleConvertCurrency = () => {
    this.setState((prev) => ({
      isOpenCurrencyConversion: !prev.isOpenCurrencyConversion
    }));
  };

  applyAndClose = (currencyValue) => {
    const code = this.pendingCurrencyCode || this.state.currencyCode;

    this.setState({
      isOpenCurrencyConversion: false,
      currencyValue,
      currencyCode: code
    });

    this.props.changeHandler({ currency_code: code, value: currencyValue });
    this.pendingCurrencyCode = null;
  };

  currencyListChangeHandler = (e) => {
    const value = e.target.value;
    const { currencyCode, currencyValue } = this.state;

    this.updateCurrencyValueByFormat({
      fromCode: currencyCode,
      toCode: value,
      selectedValue: currencyValue || 0
    });

    this.setState({ currencyCode: value });

    this.props.onCurrencyCodeChange?.(value);
  };

  updateCurrencyValueByFormat = (param, has_currency_conversion = false) => {
    const payload = {
      from_currency_code: param.fromCode,
      to_currency_code: param.toCode,
      value: param.selectedValue
    };

    callPOST('currency/convert', payload)
      .then((res) => {
        if (res?.status === 200 && res.data?.code === 200) {
          const responseData = res.data.data;
          const convertedValue = this.toFixedHandler(responseData.value);

          if (!has_currency_conversion) {
            this.setState({
              currencyValue: convertedValue,
              bottomPopup: false,
              historyCurrency: 0,
              exchangeRates: responseData
            });

            this.props.changeHandler({
              currency_code: param.toCode,
              value: convertedValue
            });
          } else {
            this.setState({ exchangeRates: responseData });
          }
        }
      })
      .catch(console.log);
  };

  render() {
    const {
      required,
      disabled,
      readOnly,
      conversionmode,//Exchange Rate Conversion
      changeHandler,
      onCurrencyCodeChange
    } = this.props;

    const {
      currencyValue,
      currencyCode,
      bottomPopup,
      currentCurrencyValue,
      historyCurrency,
      isOpenCurrencyConversion,
      exchangeRates
    } = this.state;

    const attr = setAndGetAttributes(this.props);
    const currencyList = currencyListUtil();
    const readonlyVal = !!attr?.readOnly;
    const hasExchangeRateConversion = conversionmode === true || conversionmode === 'true';

    return (
      <Wrp>
        <div className="input-group border-0">
          <div className="input-group-prepend">
            <select
              className="form-control"
              disabled={
                hasExchangeRateConversion ? true : disabled || readOnly
              }
              onChange={this.currencyListChangeHandler}
              value={currencyCode}
              {...attr}
            >
              {currencyList.map((currency, i) => (
                <option key={i} value={currency.key}>
                  {currency.value}
                </option>
              ))}
            </select>
          </div>

          <input
            type="text"
            value={currencyValue}
            onChange={(e) => this.currencyOnChange(e.target.value)}
            onBlur={(e) => this.currencyOnBlur(e.target.value)}
            {...attr}
          />

          {hasExchangeRateConversion && (
            <ExchangeRateConversion
              currency_code={currencyCode}
              currencyValue={currencyValue}
              toogleConvertCurrency={this.toogleConvertCurrency}
              isOpenCurrencyConversion={isOpenCurrencyConversion}
              updateCurrencyValueByFormat={this.updateCurrencyValueByFormat}
              exchangeRates={exchangeRates}
              applyAndClose={this.applyAndClose}
              toFixedHandler={this.toFixedHandler}
              currencyList={currencyList}
              changeHandler={changeHandler}
              fieldObj={{}}
              onChangeInputAction={(fieldObj, value, type) => {
                if (type === 'currencyType') {
                  this.pendingCurrencyCode = value;
                  this.setState({ currencyCode: value });
                  onCurrencyCodeChange?.(value);
                }
              }}
            />
          )}

          {bottomPopup && currencyValue !== 0 && currencyValue !== '' && (
            <div
              onClick={
                historyCurrency ? this.setHistoryValue : this.applyCalculatedValue
              }
              className="card currencyPop"
              style={{ cursor: 'pointer' }}
            >
              <div className="card-body p-1">
                {historyCurrency
                  ? `${historyCurrency}=${eval(historyCurrency || 0)}`
                  : `=${currentCurrencyValue}`}
              </div>
            </div>
          )}

          {!readonlyVal && (
            <div
              className={
                required ? 'mandatory input-group-append' : 'input-group-append'
              }
            >
              <a className="input-group-text" onClick={this.showHistoryPopup}>
                <i className="fas fa-info"></i>
              </a>
            </div>
          )}
        </div>
      </Wrp>
    );
  }
}

PagesCurrency.defaultProps = {
  isMandatory: false,
  required: false,
  className: 'form-control',
  decimal: 2
};

export default PagesCurrency;
